import Webapi from './webapi'
import auth from '../auth'

export default {
    geocode(street, postalCode, city, countryCode) {
        return new Webapi()
            .path('/geocode')
            .authorization(auth.get())
            .header('Content-Type', 'application/json')
            .post({
                street,
                postalCode,
                locality: city,
                country: countryCode,
            })
    },
}
